import { createRouter, createWebHistory } from 'vue-router'
import routes from './router'
import useStore  from '@/store/index'
import { getUserInfo } from '@/api/api'
import { SET_MODIFIER, SET_PARAMDATA, SET_USERINFO } from '@/store/types'
import { start, close } from "../utils/npropress";
import { primerConfig } from '@/api/primer'
import Cookies from 'js-cookie';

const store = useStore

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    ...routes,
    {
      path: '/404', // 路由没有找到 万能的路由来显示 404 页面
      component: () => import('@/components/404.vue'),
      meta: {
        title: '404',
        hidden: true,
      },
    },
    {
      path: '/:pathMatch(.*)*',//匹配未定义的路由
      redirect: '/404',//重定向
       meta: {
        displayRoute:true
      },
    }
  ],
  scrollBehavior (to) {
    // return 期望滚动到哪个的位置
    if(to) {
      return { top: 0 }
    }else {
      return {}
    }
  }
})
router.beforeEach(() => {
  start()
   // 1. 从 URL 中获取 sign 参数
  const sign = new URLSearchParams(window.location.search).get('sign');

  // 2. 如果有 sign 参数，更新 token
  if (sign) {
    // 更新 Cookies 和 store
    Cookies.set('token', sign, { path: '/' });
    useStore.commit('SET_TOKEN',sign)  // 更新 store 中的 token
  }

  const token = store.getters.getToken
  // if(to.matched.length === 0) { // 判断路由不存在
  //   router.push({path: '/404'})
  //   return true
  // }
  // if(to.meta.requireAuth) { //判断是否需要登录
    if(token) {// 已登录
      return true
    } else {
      location.href = '/login'
      return false
    }
  // }
  // return true
})
//全局前置守卫 处理异步
router.beforeResolve(async () => {
  // 获取用户信息
  const userInfo = store.state.userInfo
  try {
    if(userInfo) {
      return true
    }
    // 获取用户信息
    const res = await getUserInfo()
    // const modifier = await primerConfig()
    // const canData = await canList({ parent_id: 229 })
    // const vectorName = await canList({ parent_id: 94 })
    // const deliverables = await canList({ parent_id: 686 })
    // const enzyme = await enzymeList()
    store.commit(SET_USERINFO, res)
    // store.commit(SET_MODIFIER, modifier)
    // store.commit(SET_PARAMDATA, {
    //   enzymeList: enzyme,
    //   canData: canData,
    //   vectorName,
    //   deliverables
    // })
  } catch (error) {
    return false
  }
})
router.afterEach(() => {
  close()
})
export default router
